import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCard } from '@angular/material/card';
import { EmptyListComponent } from './empty-list/empty-list.component';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
  imports: [CommonModule, MatButtonModule, MatCard],
  declarations: [EmptyListComponent],
  exports: [EmptyListComponent],
})
export class EmptyListModule {}
